export default __webpack_public_path__ + "static/media/46.aa0cf6de.png";